export const stringToLowerCaseDashed = ( str: string ) => str.replace( /\s+/g, '-' ).toLowerCase();
export const getInitials = ( string:string ) => {
  return string
    .split( ' ' )
    .map(( word ) => word[0])
    .join( '' )
    .toUpperCase();
};

export const getUniqueInitials = ( string:string, existingInitials:string[]) => {
  let initials = getInitials( string );
  let counter = 1;
  while ( existingInitials.includes( initials )) {
    initials = getInitials( string ) + counter;
    counter++;
  }
  return initials;
};

export function capitalizeFirstLetter<S extends string>( s: S ): Capitalize<S> {
  return ( s.charAt( 0 ).toUpperCase() + s.slice( 1 )) as Capitalize<S>;
}

export function toSnakeCase( str: string ): string {
  return str
    // 1. Add an underscore before any uppercase letter,
    //    then lowercase the whole thing:
    .replace( /([A-Z])/g, '_$1' )
    // 2. Replace spaces, hyphens, and dots with underscores:
    .replace( /[\s\-.]+/g, '_' )
    // 3. Collapse multiple underscores into one:
    .replace( /_+/g, '_' )
    // 4. Trim off any leading/trailing underscores:
    .replace( /^_+|_+$/g, '' )
    // 5. Finally, lowercase all characters:
    .toLowerCase();
}